export const VERSION = '3.4.0';
export const FRONTEND_VERSION_TAG = 'v3';
